import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Silent access-token refresh on 401.
// The refresh-token cookie lives for 30 days; the access-token only 24h. Without this,
// long-lived sessions error out with "Not authenticated" on every API call until
// the user logs in again. With this, requests are transparently retried after refresh.
let refreshPromise = null;
const REFRESH_PATH = "/auth/refresh";

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";

    // Don't try to refresh:
    //  - non-401 errors
    //  - the refresh call itself (avoid loops)
    //  - login/logout/register calls
    //  - already-retried requests
    if (
      status !== 401 ||
      original._retry ||
      url.includes(REFRESH_PATH) ||
      url.includes("/auth/login") ||
      url.includes("/auth/register") ||
      url.includes("/auth/logout")
    ) {
      return Promise.reject(error);
    }

    try {
      // Coalesce concurrent 401s into a single refresh call
      refreshPromise = refreshPromise || api.post(REFRESH_PATH);
      await refreshPromise;
      refreshPromise = null;
      original._retry = true;
      return api.request(original);
    } catch (refreshErr) {
      refreshPromise = null;
      return Promise.reject(error);
    }
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
